import { EventTypeInput } from '../../types/ViewModel/EventTypeInput';
import { SelectOption } from '../../types/ViewModel/SelectOption';

export default () => {
    const MAX_CHAR_STR = 1995; // Maximum size in database: 2000

    const isDateTimeInputValid = (evTypeInput: EventTypeInput | null, dateTime: Date | null): boolean => {
        if (evTypeInput && evTypeInput.inputMandatory) {
            return !!dateTime;
        }
        return true;
    };
    const isStringInputValid = (evTypeInput: EventTypeInput | null, str: string | null): boolean => {
        if (evTypeInput && evTypeInput.inputMandatory) {
            return Boolean(str && str.trim().length > 0);
        }
        return true;
    };
    const isIntegerInputValid = (evTypeInput: EventTypeInput | null, intStr: string | null): boolean => {
        if (evTypeInput && evTypeInput.inputMandatory) {
            if (!intStr || intStr.trim().length === 0) {
                return false;
            }
            const trimmed = intStr.trim();
            return trimmed !== '-' && /^-?\d+$/.test(trimmed);
        }
        return true;
    };
    const isCheckboxInputValid = (evTypeInput: EventTypeInput | null, booleanVal: boolean | null): boolean => {
        if (evTypeInput && evTypeInput.inputMandatory) {
            return Boolean(booleanVal);
        }
        return true;
    };
    const isDecimalInputValid = (evTypeInput: EventTypeInput | null, decStr: string | null): boolean => {
        if (evTypeInput && evTypeInput.inputMandatory) {
            if (!decStr || decStr.trim().length === 0) {
                return false;
            }
            const trimmed = decStr.trim();
            if (trimmed === '-' || trimmed === '.' || trimmed === '-.') {
                return false;
            }
            return /^-?\d+(\.\d+)?$/.test(trimmed);
        }
        return true;
    };
    const isDropdownInputValid = (evTypeInput: EventTypeInput | null, selection: SelectOption[] | null): boolean => {
        if (evTypeInput && evTypeInput.inputMandatory) {
            return !!(selection && selection.length > 0);
        }
        return true;
    };
    const validateNumber = (decStr: string | null): number | null => {
        if (!decStr || decStr.trim().length === 0) {
            return null;
        }
        const trimmed = decStr.trim();
        if (trimmed === '.' || trimmed === '-' || trimmed === '-.') {
            return null;
        }
        const result = +trimmed;
        // TODO: TYPE-SAFETY - isNaN check is good but consider documenting that this function may return null for invalid numbers
        return isNaN(result) ? null : result;
    };
    const isRatingInputValid = (evTypeInput: EventTypeInput | null, numberOfStars: number | null): boolean => {
        if (evTypeInput && evTypeInput.inputMandatory) {
            return !!(numberOfStars && numberOfStars > 0);
        }
        return true;
    };
    const isRatingCommentInputValid = (evTypeInput: EventTypeInput | null, nrOfStars: number | null, comment: string | null): boolean => {
        if (comment && comment.trim().length > 0) {
            return true;
        }
        if (nrOfStars !== null && nrOfStars !== undefined) {
            return !isRatingCommentMandatory(evTypeInput, nrOfStars);
        }
        return false;
    };
    const isRatingCommentMandatory = (evTypeInput: EventTypeInput | null, nrOfStars: number): boolean => {
        if (
            evTypeInput &&
            evTypeInput.eventTypeInputRating &&
            evTypeInput.eventTypeInputRating.commentMandatoryNumbersArray &&
            evTypeInput.eventTypeInputRating.commentMandatoryNumbersArray.length > 0
        ) {
            const ratingNumber = evTypeInput.eventTypeInputRating.commentMandatoryNumbersArray.find((o) => o === nrOfStars);
            if (ratingNumber || nrOfStars === 0) {
                return true;
            }
        }
        return false;
    };

    const checkAndTruncateStr = (str: string | null): string | null => {
        // TODO: FUNCTION-MUTATION - Function mutates the input parameter 'str' by reassigning it, which could be unexpected behavior. Should create a new variable for the truncated result.
        if (str && str.length > MAX_CHAR_STR) {
            str = str.substring(0, MAX_CHAR_STR);
        }
        return str;
    };

    const getMaxCharStr = (): number => {
        return MAX_CHAR_STR;
    };

    return {
        isDateTimeInputValid,
        isStringInputValid,
        isIntegerInputValid,
        isCheckboxInputValid,
        isDecimalInputValid,
        validateNumber,
        isDropdownInputValid,
        isRatingInputValid,
        isRatingCommentInputValid,
        isRatingCommentMandatory,
        checkAndTruncateStr,
        getMaxCharStr,
    };
};
